// Copyright 2025, Imprivata, Inc.  All rights reserved.

import { Endpoints } from './constants';
import type { ConsentSubmitRequest, ConsentSubmitResponse, SelfServiceLandingPageDataResponse } from './types';
import { fetcher } from './utils';

const getSelfServiceLandingPageData = async (): Promise<SelfServiceLandingPageDataResponse> => {
  return fetcher(Endpoints.GET_SELF_SERVICE_LANDING_PAGE_DATA, {
    method: 'POST',
  });
};

const submitConsent = async (data: ConsentSubmitRequest): Promise<ConsentSubmitResponse> => {
  return fetcher(Endpoints.CONSENT_SUBMIT, {
    method: 'POST',
    body: JSON.stringify(data),
  });
};

export { getSelfServiceLandingPageData, submitConsent };
